import { FC, useState } from 'react';
import Modal from '@components/Modal';
import s from '@modals/ModalsCommon.module.scss';
import Button from '@/components/DesignLibrary/Button';
import { Input, TextArea } from '@/components/DesignLibrary/Atoms';

type Props = {
  title: string;
  description: string | null;
  onClose: () => void;
  onRename: (data: { title: string; description: string | null }) => void;
};

const RenameModal: FC<Props> = ({ onClose, onRename, title, description }) => {
  const [localTitle, setTitle] = useState(title);
  const [localDescription, setDescription] = useState(description || '');
  const [renaming, setRenaming] = useState(false);
  return (
    <Modal hideBottomInset title="Rename" onClose={onClose}>
      <div className={s.container}>
        <Input label="Title" compact value={localTitle} onChange={setTitle} />
        <TextArea label="Description" compact optional value={localDescription} onChange={setDescription} />
        <Button
          variant="primary"
          size="md"
          loading={renaming}
          onClick={() => {
            setRenaming(true);
            onRename({ description: localDescription, title: localTitle });
          }}
        >
          Save
        </Button>
      </div>
    </Modal>
  );
};

export default RenameModal;
